import { Component, NgZone,OnInit } from '@angular/core';
import {AbstractControl,  FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ApiService} from '../services/api.service';
import {AppComponent} from '../app.component';
import * as moment from 'moment';
import {  Router } from '@angular/router';
import { environment } from 'src/environments/environment';
declare var Razorpay: any;

@Component({
  selector: 'app-add-annadaan',
  templateUrl: './add-annadaan.component.html',
  styleUrls: ['./add-annadaan.component.scss']
})
export class AddAnnadaanComponent implements OnInit {
public env: any = environment;


  form: FormGroup;
  mealTypes: any[] = [];
  minDate = moment(new Date()).format('YYYY-MM-DD');
  apiLoadInterval = null;
  showPreviewModal = false;
  addPayment = false;

  allPaymentTypes = [];
  donationData: any = {};
  payment_type_id = '';
  donation_id;
  visitorDetails: any = {};
  transaction_no = '';
  transaction_validation_msg = '';
  Payform: FormGroup;
  allPaymentGateways = [];

  constructor(
    private _formBuilder: FormBuilder,
    private apiService : ApiService,
    private appComponent: AppComponent,
    private router: Router,
    private _ngZone: NgZone
    ) {
    }

  ngOnInit() {
    this.createForm();
    this.getAllPaymentTypes();
  }

  createForm() {
    this.form = this._formBuilder.group({
      donation_date: ['', Validators.required],

      annakshetra_meal_type_id: ['', Validators.required],
      mobile_no: ['',[Validators.required,Validators.pattern('^[0-9]{10}$')]],

      full_name: ['', Validators.required],
      hindi_name: [''],

      occasion: [''],
      hindi_occasion: [''],

      address: [''],

      require_80g_certificate: [false],

      pan_card_no: ['']
    });
  }

  openPreview() {
    this.showPreviewModal = true;
  }

  closePreview() {
    this.showPreviewModal = false;
  }

  onDateChange() {
    const date = moment(
      this.form.value.donation_date
    ).format('YYYY-MM-DD');

    this.apiService
      .getDataFromServer(
        `/annakshetra_meal_types`
      )
      .subscribe(
        (res: any) => {
          this.mealTypes = res.data || [];
        },
        err => {
          console.log(err);
        }
      );
  }

  on80GChange() {
    const panControl = this.form.get('pan_card_no');

    if (this.form.value.require_80g_certificate) {
      panControl.setValidators([
        Validators.required,
        Validators.pattern('[A-Z]{5}[0-9]{4}[A-Z]{1}')
      ]);
    } else {
      panControl.clearValidators();
      panControl.setValue('');
    }

    panControl.updateValueAndValidity();
  }

  saveData() {

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const formData = {
      ...this.form.value,
      donation_date: moment(
        this.form.value.donation_date
      ).format('YYYY-MM-DD')
    };

    this.appComponent.showLoader();

    this.apiService
      .postDataToServer('/annakshetra_donations',formData)
      .subscribe(
        (res: any) => {

          this.appComponent.hideLoader();
          // this.router.navigate(['/annadaan']);
          this.addPayment = true;
          this.donationData = res.data;
          this.donation_id = res.data.id;
          this.appComponent.showMessageAlert(
            res.message,
            'success'
          );
        },
        err => {
          this.appComponent.hideLoader();

          this.appComponent.showMessageAlert(
            err.error.error[0].message,
            'error'
          );
        }
      );
  }

  close() {
    this.router.navigate(['/annadaan']);
  }

  getAllPaymentTypes() {
    this.apiService.getDataFromServer('/payment_types').subscribe(
      res => {
        this.allPaymentTypes = res['data'];
      },
      err => {
        console.log(err);
      }
    );
  }

  addPaymentDetail() {
    this.createPayForm();
    this.saveDataOfPayment();
  }
  
  removeSpaces(control: AbstractControl) {
    if (control && control.value && !control.value.replace(/\s/g, '').length) {
      control.setValue('');
    }
    return null;
  }
  
  removeSpacesTransaction_no() {
    setTimeout(() => {
      const isWhitespace = (this.transaction_no).trim().length === 0;
      if (isWhitespace) {
        this.transaction_validation_msg = 'Please Enter Valid Transaction No. / Receipt No.'
      } else {
        this.transaction_validation_msg = ''
      }
    },200);
  
  }
  
  createPayForm() {
    this.Payform = this._formBuilder.group({
        payer_full_name: this.donationData.full_name,
        service_id: this.donationData.id,
        payer_contact: this.donationData.mobile_no || '',
        payment_type_id:[this.payment_type_id,[Validators.required]],
        service_type: 'Annakshetra Donation',
        payment_gateway_id: 2
    });
  
  }
  
  
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  
  closePay() {
    this.addPayment = false;
    // this.createPayForm();
  }
  
  saveDataOfPayment() {
    this.appComponent.showLoader();
    this.apiService.postDataToServer('/make_payment', this.Payform.value).subscribe(
      (res:any) => {
        if(res.success) {
          // window.open(res.url);
          if(this.Payform.value.payment_gateway_id == 2){
            let _data = res.data;
            let options = {
              "key": this.env.razorpay_key,
              "amount": (_data.amount * 100),
              "currency": _data.currency,
              "name": "Mahakaleshwar Temple Prabhand Samiti Ujjain",
              "order_id": _data.id,
              "handler": (response: any) => {
                this.verifyPayment(response);
              },
              "prefill": {
                "name": _data.prefill_fields.name,
                "email": _data.prefill_fields.email,
                "contact": _data.prefill_fields.contact
              }
            };
            var rzp1 = new Razorpay(options);
  
            rzp1.open();
          } else {
            window.location.replace(res.url);
          }
        }
  
        this.appComponent.hideLoader();
      },
      err => {
        this.appComponent.hideLoader();
        this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
        console.log(err);
      }
    );
  }
  
  viewPass() {
    this.appComponent.showLoader();
    this.apiService.getDataFromServer('/generate_entry_pass/' + this.donation_id).subscribe(
      res => {
        window.open(res['data'][0]);
        this.appComponent.hideLoader();
      },
      err => {
        console.log(err);
      }
    );
  }
  
  savePayData() {
     let formObj = {
       service_id : this.donation_id,
       payment_type_id : this.payment_type_id,
       amount: this.donationData.amount,
       trx_id:  this.transaction_no
     };
  
    this.appComponent.showLoader();
    this.apiService.postPublicDataToServer('/annakshetra_donations/payment', formObj).subscribe(
        (res:any) => {
          this.appComponent.showMessageAlert(res['message'], 'success');
          this.appComponent.hideLoader();
          this.router.navigate(['/annadaan']);
          this.closePay();
        },
        err => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
          console.log(err);
        }
      );
  }
  
    verifyPayment(_data : any) {
      this.appComponent.showLoader();
      let formObj = {
        razorpay_payment_id: _data.razorpay_payment_id,
        razorpay_order_id: _data.razorpay_order_id,
        razorpay_signature: _data.razorpay_signature
      };
  
      this.apiService.postPublicDataToServer('/verify_payment', formObj).subscribe(
        (res : any) => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(res['message'], 'success');
          this._ngZone.run(()=>{
            // this.router.navigate(['/payment-status'], {queryParams: {redirect: true , clientTxnId: res['data']['clientTxnId'] }});
            this.router.navigate(['/annadaan']);
          });
  
        },
        err => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
          console.log(err);
        }
      );
    }

}
